// src/api/supplierApi.ts

import { ENV } from '../../config/runtimeEnv';
import { http } from "../../lib/http/client";
const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;

export interface Supplier {
    supplier_id?: number;
    name: string;
    contact_name?: string;
    email?: string;
    phone?: string;
    address?: string;
}

export const fetchSuppliers = async (page: number = 1, perPage: number = 20, search?: string): Promise<{ data: Supplier[]; total: number }> => {
	const params: any = {
		page,
		per_page: perPage,
	};
	if (search) {
		params.search = search;
	}

	const response = await http.get(`${API_BASE_URL}/suppliers`, {
		params,
	});
    return {
        data: response.data.data,
        total: response.data.total,
    };
};

export const fetchSupplier = async (supplier_id: number): Promise<Supplier> => {
    const response = await http.get(`${API_BASE_URL}/suppliers/${supplier_id}`);
    return response.data;
};

export const createSupplier = async (supplierData: Supplier): Promise<Supplier> => {
    const response = await http.post(`${API_BASE_URL}/suppliers`, supplierData);
    return response.data;
};

export const updateSupplier = async (supplier_id: number, supplierData: Partial<Supplier>): Promise<Supplier> => {
    const response = await http.put(`${API_BASE_URL}/suppliers/${supplier_id}`, supplierData);
    return response.data;
};

export const deleteSupplier = async (supplier_id: number): Promise<void> => {
    await http.delete(`${API_BASE_URL}/suppliers/${supplier_id}`);
};
